import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function AdminEdit(props) {
  const { updateTable, setUpdateTable, admin } = props;

  const [openEditDialog, setOpenEditDialog] = useState(false);

  const [firstName, setFirstName] = useState(admin.firstName);
  const [lastName, setLastName] = useState(admin.lastName);
  const [email, setEmail] = useState(admin.email);
  const [username, setUsername] = useState(admin.pid);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    // Set the fields back to the admin's data
    setFirstName(admin.firstName);
    setLastName(admin.lastName);
    setEmail(admin.email);
    setUsername(admin.pid);
  }, [admin, openEditDialog]);

  const handleEditAdmin = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("adminId", admin.adminId);
    body.append("firstName", firstName);
    body.append("lastName", lastName);
    body.append("email", email);
    body.append("pid", username);
    axios.post("/admin/editAdmin", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setUsername("");
  };

  function showEditDialog(open) {
    return (
      <Dialog open={open} maxWidth={false}>
        <DialogTitle className="AdminEdit-title mx-auto text-2xl font-bold font-brand-primary">
          Edit Admin
        </DialogTitle>
        <div className="AdminEdit-modalContainer flex flex-col w-fit px-4">
          <div className="AdminEdit-nameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminEdit-name text-lg font-brand-primary">
              First Name *
            </div>
            <CreateValidateTextField
              placeholder="John"
              pattern="[a-zA-Z-]+( [a-zA-Z-]+)*"
              value={firstName}
              setter={setFirstName}
              errorMessage={"Invalid First Name."}
              required={true}
            />
          </div>
          <div className="AdminEdit-nameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminEdit-name text-lg font-brand-primary">
              Last Name *
            </div>
            <CreateValidateTextField
              placeholder="Doe"
              pattern="[a-zA-Z-]+( [a-zA-Z-]+)*"
              value={lastName}
              setter={setLastName}
              errorMessage={"Invalid Last Name."}
              required={true}
            />
          </div>
          <div className="AdminEdit-usernameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminEdit-username text-lg font-brand-primary">
              Username *
            </div>
            <CreateValidateTextField
              placeholder="jDoe"
              pattern="\w+"
              value={username}
              setter={setUsername}
              errorMessage={"Invalid username."}
              required={true}
            />
          </div>
          <div className="AdminEdit-emailContainer flex flex-col w-96 mx-auto mb-2">
            <div className="AdminEdit-email text-lg font-brand-primary">
              Email *
            </div>
            <CreateValidateTextField
              placeholder="jDoe@vt.com"
              pattern="[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}"
              value={email}
              setter={setEmail}
              errorMessage={"Invalid Email."}
              required={true}
            />
          </div>
          <div className="AdminEdit-buttonContainer flex justify-between px-8">
            <button
              type="button"
              className="AdminEdit-updateButton primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleEditAdmin}
            >
              Update Admin
            </button>

            <button
              type="button"
              className="AdminEdit-cancelButton primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => {
                setOpenEditDialog(false);
                resetHooks();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="AdminEdit-container">
      {showEditDialog(openEditDialog)}
      <button className="flex mr-4" onClick={() => setOpenEditDialog(true)}>
        <EditIcon fontSize="large" className="fill-brand-quaternary" />
      </button>
    </div>
  );
}

AdminEdit.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  admin: PropTypes.shape({
    adminId: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    pid: PropTypes.string,
    email: PropTypes.string,
  }),
};

AdminEdit.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
};

export default AdminEdit;
